import React, {Component, ReactElement, ReactNode} from 'react'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Nullable} from '../../../app/TypeHelpers'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../components/shared/hoc/withAdminPageTemplate'
import {AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons'
import {BackLink} from '../../../styledComponents/adminPage/Links'
import NatFacilityRepo from '../facility/repository/NatFacilityRepo'
import {FacilityIntroductoryInfo, NatGetFacilityIntroductory} from './repository/NatGetFacilityIntroductory'
import {NatPutFacilityIntroductory, NatPutFacilityIntroductoryParams} from './repository/NatPutFacilityIntroductory'
import {StyledTableCaption, TableRowName} from '../../../styledComponents/adminPage/Table'
import PPHtmlEditor from '../../../components/shared/forms/PPHtmlEditor'
import {Messages} from '../../../Messages'
import {MESSAGE_TYPE} from '../../../CodeMaster'
import {Location} from 'react-router-dom'

import {Table, TableBody, TableCell, TableRow} from '@mui/material'

interface LocationState {
    previousPageUrl: string
    previousPageName: string
}

interface Props {
    condominiumCd: string
    facilityId: string
    facilityRepo: NatFacilityRepo
    eventEmitter: EventEmitterExAdmin
    location: Location<LocationState>
}

interface States {
    facilityIntroductoryInfo: FacilityIntroductoryInfo
    facilityIntroductoryInputValue: string
    isLoadCompleted: boolean
    previousPageUrl: string
    previousPageName: string
}


class NatAdminFacilityIntroductoryEditPage extends Component<Props & AdminPagePropsSet, States> {

    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        this.state = {
            facilityIntroductoryInfo: {
                facilityId: '',
                facilityName: '',
                facilityIntroductory: '',
                version: 0,
            },
            facilityIntroductoryInputValue: '',
            isLoadCompleted: false,
            previousPageUrl: '',
            previousPageName: '',
        }
        this.backFacilityIntroductoryLinkClick = this.backFacilityIntroductoryLinkClick.bind(this)
        this.handleRegisterCancelClick = this.handleRegisterCancelClick.bind(this)
        this.handleRegisterOkClick = this.handleRegisterOkClick.bind(this)
        this.onChangeFacilityIntroductory = this.onChangeFacilityIntroductory.bind(this)
        this.editFacilityIntroductoryButton = this.editFacilityIntroductoryButton.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            // 施設紹介文取得
            const facilityIntroductoryResponse: Nullable<NatGetFacilityIntroductory> =
                await this.props.asyncCallFunction(
                    this.props.facilityRepo.getFacilityIntroductory.bind(
                        this.props.facilityRepo, this.props.facilityId),
                    (httpErrorOrNetworkError) => {
                        this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                    },
                )
            if (facilityIntroductoryResponse && facilityIntroductoryResponse.details) {
                this.setState({
                    facilityIntroductoryInfo: facilityIntroductoryResponse.details,
                    facilityIntroductoryInputValue: facilityIntroductoryResponse.details.facilityIntroductory,
                })
            }

        } finally {

            let previousPageUrl: string = ''
            let previousPageName: string = ''
            if (this.props.location.state && this.props.location.state.previousPageUrl) {
                previousPageUrl = this.props.location.state.previousPageUrl
            }
            if (this.props.location.state && this.props.location.state.previousPageName) {
                previousPageName = this.props.location.state.previousPageName
            }
            this.setState({
                previousPageUrl: previousPageUrl,
                previousPageName: previousPageName,
            })

            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

    async editFacilityIntroductoryButton(): Promise<void> {

        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: Messages.IOPCC0010.errorLevel,
                message: Messages.IOPCC0010.toString(`${this.state.facilityIntroductoryInfo.facilityName}の紹介文`),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleRegisterCancelClick,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.handleRegisterOkClick,
                    },
                ],
            },
        )

    }

    async handleRegisterOkClick(): Promise<void> {
        this.props.eventEmitter.closeDialog()
        await this.props.eventEmitter.showLoading()

        try {
            const putFacilityIntroductoryParams: NatPutFacilityIntroductoryParams = {
                facilityId: this.props.facilityId,
                facilityIntroductory: this.state.facilityIntroductoryInputValue,
                version: this.state.facilityIntroductoryInfo.version,
            }
            const response: Nullable<NatPutFacilityIntroductory> =
                await this.props.asyncCallFunction(
                    this.props.facilityRepo.putFacilityIntroductory.bind(
                        this.props.facilityRepo, putFacilityIntroductoryParams,
                    ),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.EOPCA0002.toString('施設説明文')},
                )
            if (response && response.requestError === null) {
                this.props.navigate(
                    this.state.previousPageUrl,
                    {
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: Messages.IOPCC0005.toString(`施設`, `${this.state.facilityIntroductoryInfo.facilityName}の紹介文`),
                            },
                        },
                    },
                )
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    onChangeFacilityIntroductory(value: string): void {
        this.setState({facilityIntroductoryInputValue: value})
    }

    backFacilityIntroductoryLinkClick(): void {
        this.props.navigate(this.state.previousPageUrl)
    }

    handleRegisterCancelClick(): void {
        this.props.eventEmitter.closeDialog()
    }


    renderPageFooterArea(): ReactNode {
        return (
            <>
                <PageFotterAreaRight>
                    <AdminPrimaryButton
                        disabled={false}
                        onClick={this.editFacilityIntroductoryButton}
                    >
                        登録
                    </AdminPrimaryButton>
                </PageFotterAreaRight>
                <PageFotterAreaLeft>
                    <BackLink
                        onClick={this.backFacilityIntroductoryLinkClick}
                    >
                        {this.state.previousPageName}へ戻る
                    </BackLink>
                </PageFotterAreaLeft>
            </>
        )
    }


    renderDetailsTable(): ReactElement {
        return (
            <>
                <Table>
                    <StyledTableCaption>施設情報</StyledTableCaption>
                    <TableBody>
                        <TableRow>
                            <TableRowName>施設名</TableRowName>
                            <TableCell>
                                {this.state.facilityIntroductoryInfo.facilityName}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>施設紹介文</TableRowName>
                            <TableCell>
                                <PPHtmlEditor
                                    onEditorChange={this.onChangeFacilityIntroductory}
                                    value={this.state.facilityIntroductoryInputValue}
                                    eventKeys={['facilityIntroductory']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </>
        )
    }


    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }
        return (
            <>
                <PageMainArea>
                    {this.renderDetailsTable()}
                </PageMainArea>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>
        )
    }
}

export default createAdminPage(NatAdminFacilityIntroductoryEditPage)

